module.exports = __webpack_public_path__ + "ru.5e2c1a13ffbfa0bf4346.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ru.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ru.svg
// module chunks = styles